import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between items-center" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "flex justify-between items-center" }
const _hoisted_6 = { class: "text-3xl font-bold" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "grid grid-cols-4 gap-4 mb-3" }
const _hoisted_9 = { class: "flex flex-col col-span-2" }
const _hoisted_10 = { class: "flex justify-end" }
const _hoisted_11 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "border border-next-neu rounded text-center text-xs" }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "grid grid-cols-4 gap-4 mb-3" }
const _hoisted_16 = { class: "flex flex-col col-span-2" }
const _hoisted_17 = { class: "rotate-x-180 overflow-x-scroll" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ConfermaModal = _resolveComponent("ConfermaModal")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Switcher = _resolveComponent("Switcher")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_TableTooltip = _resolveComponent("TableTooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TabellaContextMenu = _resolveComponent("TabellaContextMenu")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"]),
      (_ctx.confirmDelete)
        ? (_openBlock(), _createBlock(_component_ConfermaModal, {
            key: 0,
            backdrop: false,
            visible: _ctx.confirmDelete,
            onReject: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmDelete = false)),
            onConfirm: _ctx.performDelete
          }, null, 8, ["visible", "onConfirm"]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back())),
              variant: "outline-secondary",
              class: "w-44 text-sm py-2 px-4"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            }),
            (_ctx.rubrica === 0)
              ? (_openBlock(), _createBlock(_component_NextButton, {
                  key: 0,
                  component: "router-link",
                  to: {name: 'NuovoCliente'},
                  variant: "primary",
                  class: "w-44 ml-3 text-sm py-2 px-4 m-0 hidden sm:block"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode(" + Aggiungi ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.rubrica === 0 ? "Lista clienti" : "Lista contatti"), 1),
          _createVNode(_component_Switcher, {
            modelValue: _ctx.rubrica,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rubrica) = $event)),
            options: ['Tutti i clienti', 'Tutti i contatti'],
            class: "my-5"
          }, null, 8, ["modelValue"])
        ]),
        (!_ctx.rubrica)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Field, {
                    field_name: "Cerca",
                    "onUpdate:modelValue": [
                      _ctx.listaAziende.debounceSearch,
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.listaAziende.search) = $event))
                    ],
                    modelValue: _ctx.listaAziende.search,
                    placeholder: "Cerca"
                  }, null, 8, ["onUpdate:modelValue", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_Paginator, {
                  pagination: _ctx.listaAziende.paginate
                }, null, 8, ["pagination"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 table-fixed w-full border-separate border-spacing-3 py-4",
                  cols: _ctx.aziendeCols,
                  "onUpdate:cols": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.aziendeCols) = $event)),
                  pagination: _ctx.listaAziende.paginate,
                  rows: _ctx.listaAziende.rows,
                  onOrderUpdate: _ctx.listaAziende.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaAziende.rows, (c, j) => {
                    return {
                      name: `td_${j}_0`,
                      fn: _withCtx(({context}) => [
                        _createVNode(_component_TableTooltip, {
                          inner_class: context.cell.td_class
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(context.row[context.cell.prop]), 1)
                          ]),
                          _: 2
                        }, 1032, ["inner_class"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaAziende.rows, (c, j) => {
                    return {
                      name: `td_${j}_1`,
                      fn: _withCtx(({context}) => [
                        _createVNode(_component_TableTooltip, {
                          inner_class: context.cell.td_class
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(context.row[context.cell.prop]), 1)
                          ]),
                          _: 2
                        }, 1032, ["inner_class"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaAziende.rows, (c, j) => {
                    return {
                      name: `td_${j}_4`,
                      fn: _withCtx((context) => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioAzienda', params:{id:context.context.row.id}},
                          class: "text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaAziende.rows, (c, j) => {
                    return {
                      name: `td_${j}_5`,
                      fn: _withCtx(() => [
                        _createVNode(_component_TabellaContextMenu, {
                          menuClass: "shadow absolute pr-10 flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                          buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                          context: c,
                          id: j,
                          teleport_to: "#modal",
                          cmOpener: _ctx.cmOpener
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: {name:'Attivita', params: {id:c.id}},
                              class: "hover:text-next-neu mb-2"
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode("Attività ")
                              ])),
                              _: 2
                            }, 1032, ["to"]),
                            _createVNode(_component_router_link, {
                              to: {name:'Contatti', params: {id:c.id}},
                              class: "hover:text-next-neu mb-2"
                            }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode("Contatti ")
                              ])),
                              _: 2
                            }, 1032, ["to"]),
                            (_ctx.isNewBusiness)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  onClick: ($event: any) => (_ctx.cancellaAzienda(c.id)),
                                  class: "text-next-orange"
                                }, "Elimina", 8, _hoisted_12))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["context", "id", "cmOpener"])
                      ])
                    }
                  }),
                  _renderList(_ctx.listaAziende.rows, (c, j) => {
                    return {
                      name: `td_${j}_3`,
                      fn: _withCtx((context) => [
                        _createTextVNode(_toDisplayString(_ctx.$filters.toDate(context.context.row.ultimo_contatto)), 1)
                      ])
                    }
                  }),
                  _renderList(_ctx.listaAziende.rows, (c, j) => {
                    return {
                      name: `td_${j}_2`,
                      fn: _withCtx(({context}) => [
                        _createElementVNode("div", {
                          class: "grid gap-1",
                          style: _normalizeStyle({'grid-template-columns': `repeat(${_ctx.businessUnits.length}, minmax(0, 1fr))`})
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.businessUnits, (bu) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "tooltip-activator relative cursor-pointer",
                              key: bu.id
                            }, [
                              _createElementVNode("div", _hoisted_13, _toDisplayString(bu.label), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass([`bg-next-${_ctx.getColoriStati(context.row.stati[bu.id])}`, "border rounded text-center text-xs text-white"])
                              }, _toDisplayString(_ctx.getLabel(context.row.stati[bu.id])), 3),
                              _createVNode(_component_Tooltip, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.getTooltip(context.row.stati[bu.id])), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ], 4)
                      ])
                    }
                  })
                ]), 1032, ["cols", "pagination", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaAziende.fetchNextPage,
                identifier: _ctx.listaAziende.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri clienti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Field, {
                    field_name: "Cerca",
                    "onUpdate:modelValue": [
                      _ctx.listaContatti.debounceSearch,
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.listaContatti.search) = $event))
                    ],
                    modelValue: _ctx.listaContatti.search,
                    placeholder: "Cerca"
                  }, null, 8, ["onUpdate:modelValue", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_NextTable, {
                  class: "rotate-x-180 w-full border-separate border-spacing-3 py-4",
                  cols: _ctx.contattiCols,
                  "onUpdate:cols": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.contattiCols) = $event)),
                  rows: _ctx.listaContatti.rows,
                  onOrderUpdate: _ctx.listaContatti.updateCols
                }, _createSlots({ _: 2 }, [
                  _renderList(_ctx.listaContatti.rows, (c, j) => {
                    return {
                      name: `td_${j}_7`,
                      fn: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {name:'DettaglioContatto', params:{id:c.cliente_id, cid:c.id}},
                          class: "text-center inset-0 absolute flex items-center justify-center"
                        }, {
                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                            _createElementVNode("i", { class: "icon-chevron_destra" }, null, -1)
                          ])),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    }
                  })
                ]), 1032, ["cols", "rows", "onOrderUpdate"])
              ]),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.listaContatti.fetchNextPage,
                identifier: _ctx.listaContatti.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[14] || (_cache[14] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altri contatti.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ]))
      ])
    ])
  ], 64))
}